const CloseModal = () => {
    return (
      <span className="text-secondary h4">x</span>
    );
  }
  
  export default CloseModal;